<div class="err-msg-container">
  <span class="e-icons e-error-treeview"></span>
  <span class="err-msg">{{ errMsg }}</span>
  <br/>
  <br/>
  <neo-button buttonType="borderless" text="Back to Home" routerLink="/"></neo-button>
</div>
